import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Sprout } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { logError } from "@/lib/log";

export const MiaPlaybookCard = () => {
  const [st, setSt] = useState(null);
  useEffect(() => { api.get("/playbook/settings").then((r) => setSt(r.data)).catch((e) => logError("Playbook settings failed:", e)); }, []);
  const change = (key, msg) => async (v) => {
    setSt((x) => ({ ...x, [key]: v }));
    try { await api.put("/playbook/settings", { [key]: v }); toast.success(msg[v ? 0 : 1]); }
    catch (e) { setSt((x) => ({ ...x, [key]: !v })); toast.error(errMsg(e)); }
  };
  if (st === null) return null;
  const on = st.mia_playbook;
  return (
    <div className="mm-card p-5 space-y-4" data-testid="mia-playbook-card">
    <div className="flex items-start justify-between gap-4">
      <div className="flex gap-3">
        <Sprout size={20} className="text-mm-primary shrink-0 mt-0.5" />
        <div><div className="font-semibold">Let Mia use my playbook</div>
          <p className="text-sm text-mm-muted mt-0.5">Mia can suggest what helped you before, from your <Link to="/playbook" className="text-mm-primary font-semibold">What Helps Me</Link> summary. She never sees your journal text.</p></div>
      </div>
      <Switch checked={on} onCheckedChange={change("mia_playbook", ["Mia can use your playbook", "Mia won't use your playbook"])} data-testid="mia-playbook-switch" />
    </div>
    <div className="flex items-start justify-between gap-4 border-t border-mm-primary/10 pt-4">
      <div className="flex gap-3">
        <span className="shrink-0" aria-hidden>🌤️</span>
        <div><div className="font-semibold">Early warning nudges</div>
          <p className="text-sm text-mm-muted mt-0.5">A gentle heads-up when today looks like one of your early signs, with ideas from your playbook. At most once every 3 days.</p></div>
      </div>
      <Switch checked={st.early_warning_nudges} onCheckedChange={change("early_warning_nudges", ["Early warning nudges on", "Early warning nudges off"])} data-testid="early-warning-switch" />
    </div>
    </div>
  );
};
